(function () {
  var selectedCountry = 'us';
  if (window.Shopify) {
    selectedCountry = (Shopify.country || '').toLowerCase() || selectedCountry;
    if (!Shopify.country && Shopify.locale) {
      var parts = Shopify.locale.split('-');
      selectedCountry = (parts.pop() || parts[0] || selectedCountry).toLowerCase();
    }
  }

  var pattern = /\[country="([^"]+)"\]([\s\S]*?)\[\/country\]/gi;

  function replaceShortcodes(text) {
    if (!pattern.test(text)) {
      return text;
    }
    pattern.lastIndex = 0;

    var hasMatchForCountry = false;
    var fallbackContent = null;
    var match;

    while ((match = pattern.exec(text)) !== null) {
      if (fallbackContent === null) {
        fallbackContent = match[2];
      }
      var codes = match[1].split(',').map(function (c) { return c.trim().toLowerCase(); });
      if (codes.indexOf(selectedCountry) !== -1) {
        hasMatchForCountry = true;
        break;
      }
    }

    pattern.lastIndex = 0;
    var result = '';
    var lastIndex = 0;

    while ((match = pattern.exec(text)) !== null) {
      result += text.slice(lastIndex, match.index);
      var list = match[1].split(',').map(function (c) { return c.trim().toLowerCase(); });
      if (hasMatchForCountry && list.indexOf(selectedCountry) !== -1) {
        result += match[2];
      } else if (!hasMatchForCountry && fallbackContent !== null) {
        result += fallbackContent;
      }
      lastIndex = pattern.lastIndex;
    }

    result += text.slice(lastIndex);
    return result;
  }

  function walk(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var original = node.nodeValue;
      if (original && original.indexOf('[country="') !== -1) {
        var updated = replaceShortcodes(original);
        if (updated !== original) {
          node.nodeValue = updated;
        }
      }
      return;
    }
    if (node.nodeType === Node.ELEMENT_NODE && node.childNodes) {
      Array.prototype.forEach.call(node.childNodes, walk);
    }
  }

  function run() {
    var container = document.querySelector('#MainContent');
    if (!container) return;
    walk(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
